import { render } from "./HomePage.vue?vue&type=template&id=778cdfdf&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=778cdfdf&lang=scss&scoped=true"

import exportComponent from "/Users/mattbio/dev/gym-buddy-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778cdfdf"]])

export default __exports__